import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class QuickPostSurface extends BaseOption {
  static userInterfaceComponent = {
    label: "Composer surface",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          label: "Card",
          value: "card",
        },
        {
          label: "Plain",
          value: "plain",
        },
      ],
    },
  };

  static defaultValue = "card";
}
